// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-AuditLogs-styles___container--ZPDSf {
  padding: 40px;
  max-width: 100%;
  margin: 0;
}

.pages-AuditLogs-styles___title--d3Rzh {
  margin: 0 0 24px;
  font-size: 24px;
  font-weight: 700;
}

.pages-AuditLogs-styles___filters--zhbAC {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-bottom: 24px;
}

.pages-AuditLogs-styles___filterInput--t5PMc {
  width: 160px;
}

.pages-AuditLogs-styles___userFilterInput--fPc0p {
  width: 260px;
}

.pages-AuditLogs-styles___dateFilterInput--ykaJO {
  width: 280px;
}

.pages-AuditLogs-styles___searchButton--RGkBX {
  height: 40px;
}

.pages-AuditLogs-styles___loader--RuWTv {
  display: flex;
  justify-content: center;
  padding: 48px 0;
}

.pages-AuditLogs-styles___empty--xjoJM {
  color: #666;
  font-size: 14px;
}

.pages-AuditLogs-styles___clickableRow--abtlq {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./pages/AuditLogs/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".container {\n  padding: 40px;\n  max-width: 100%;\n  margin: 0;\n}\n\n.title {\n  margin: 0 0 24px;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.filterInput {\n  width: 160px;\n}\n\n.userFilterInput {\n  width: 260px;\n}\n\n.dateFilterInput {\n  width: 280px;\n}\n\n.searchButton {\n  height: 40px;\n}\n\n.loader {\n  display: flex;\n  justify-content: center;\n  padding: 48px 0;\n}\n\n.empty {\n  color: #666;\n  font-size: 14px;\n}\n\n.clickableRow {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `pages-AuditLogs-styles___container--ZPDSf`,
	"title": `pages-AuditLogs-styles___title--d3Rzh`,
	"filters": `pages-AuditLogs-styles___filters--zhbAC`,
	"filterInput": `pages-AuditLogs-styles___filterInput--t5PMc`,
	"userFilterInput": `pages-AuditLogs-styles___userFilterInput--fPc0p`,
	"dateFilterInput": `pages-AuditLogs-styles___dateFilterInput--ykaJO`,
	"searchButton": `pages-AuditLogs-styles___searchButton--RGkBX`,
	"loader": `pages-AuditLogs-styles___loader--RuWTv`,
	"empty": `pages-AuditLogs-styles___empty--xjoJM`,
	"clickableRow": `pages-AuditLogs-styles___clickableRow--abtlq`
};
module.exports = ___CSS_LOADER_EXPORT___;
